var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M20.182 3.905H3.818C2.814 3.905 2 4.758 2 5.81v14.285C2 21.147 2.814 22 3.818 22h16.364C21.186 22 22 21.147 22 20.095V5.81c0-1.052-.814-1.905-1.818-1.905zM7.455 2v3.81M16.545 2v3.81M2 9.62h20"}));
}

Calendar.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Calendar;

Calendar.default = Calendar;
